export const profileImg = require('assets/default-profile-image.svg').default;
export const APIDefaultImage = 'http://146.56.183.55:5050/Ellipse.png';
export const MainAccountToken =
  'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjY0OTQyNTVlYjJjYjIwNTY2MzY5ZmE1YyIsImV4cCI6MTcwNjkxNTI5NywiaWF0IjoxNzAxNzMxMjk3fQ.fKrKAqC3zIyeMQycAicDQGEpMXj4X1NTMB09JSLuXxY';
export const BASEURL = 'https://api.mandarin.weniv.co.kr/';
